<template>
  <l-layout :layout="[ 'xs12']" bottom-space>
    <l-data-table
      :get-data-func="getGroupTypes"
      :headers="headers"
      @click:row="goDetails($event.item)"
      clickable
      init-sort-by="name"
      ref="dataTable"
      selectable
      title-text="分组类型列表"
      search-text="搜索类型名称"
      v-model="selected"
    >
      <template slot="title-action">
        <l-option-menu
          :options="moreActions"
        >
          <v-btn icon slot="activator">
            <v-icon>$vuetify.icons.more</v-icon>
          </v-btn>
        </l-option-menu>
      </template>
      <template slot="row-action" slot-scope="{item}">
        <td @click.stop class="px-0 mx-0 text-xs-center">
          <v-btn @click="deleteGroupType(item)" icon>
            <v-icon small>$vuetify.icons.delete</v-icon>
          </v-btn>
        </td>
      </template>
    </l-data-table>
    <l-fixed-btn
      @click="goNew"
      icon="$vuetify.icons.add"
    ></l-fixed-btn>
  </l-layout>
</template>

<script>
import {time} from '../../../../ladmin/utils'

export default {
  name: 'GroupTypeList',
  props: ['refresh'],
  data: () => ({
    selected: [],
    floatingButton: false,
    moreActions: [
      {
        event: 'delete',
        label: '批量删除',
        icon: '$vuetify.icons.deleteAll'
      },
      // {
      //   event: 'export',
      //   label: '导出PDF',
      //   icon: '$vuetify.icons.description'
      // }
    ],
    headers: [
      {text: '类型名称', value: 'name', align: 'left', placeholder: 'N/A'},
      {text: '类型描述', value: 'description', align: 'right', placeholder: 'N/A', maxWidth: '14em', tooltip: true},
      {text: '上次修订', value: 'lastUpdateTime', align: 'right', placeholder: 'N/A', f: v => time.stringify(v)},
      {text: '修订人员', value: 'lastEditor', align: 'right', placeholder: 'N/A'},
      {text: '', value: '', align: 'right', width: '80px', sortable: false}
    ],
  }),
  methods: {
    async getGroupTypes ({pagination, sortStack, filterItems, search}) {
      return this.$store.dispatch('userAdmin/getGroupTypes', {
        pagination,
        sortStack,
        filter: filterItems,
        search: {key: 'name', value: search},
      })
    },
    async deleteGroupType (type) {
      // console.log(user)
      if (!type) return
      let {res, close} = await this.$L.confirm({
        title: '确认删除该分组类型？',
        text: type.name || `N/A`,
      })
      if (res) {
        try {
          await this.$store.dispatch('userAdmin/deleteGroupTypes', [type])
          this.$refs.dataTable.refresh()
          this.$L.alert('success', {message: '删除成功'})
        }
        catch (e) {
          this.$L.alert('error', e.message)
        }
      }
      close()
    },
    goDetails (item, force) {
      let selectionString = document.getSelection().toString()
      if (!selectionString || force) {
        this.$router.push({
          name: 'GroupTypeDetails',
          params: {name: item.name},
          query: {id: item.id}
        })
      }
    },
    goNew () {
      this.$router.push({
        name: 'NewGroupType'
      })
    }
  },
  activated () {
    console.log('tyoeList', this.refresh)
    if (this.refresh) {
      this.$refs.dataTable.refresh()
    }
  },
}
</script>

<style scoped>

</style>
